export const dataScienceSyllabus = {

    basic: [

        {
            id: "ds-basic-1",
            title: "Python & Setup",
            content: [
                "Python environment setup",
                "Python programming fundamentals",
                "Working with Python for Data Science",
            ],
        },

        {
            id: "ds-basic-2",
            title: "Programming & SQL Foundations",
            content: [
                "Programming fundamentals",
                "SQL foundations",
                "Working with databases",
                "Querying and retrieving data",
            ],
        },

        {
            id: "ds-basic-3",
            title: "Data Handling & Visualization",
            content: [
                "Data handling",
                "Data manipulation",
                "Data visualization",
                "Working with data for analysis",
            ],
        },

        {
            id: "ds-basic-4",
            title: "ML Foundations & Generative AI",
            content: [
                "Machine Learning foundations",
                "Introduction to Generative AI",
                "AI and Machine Learning concepts",
                "Applications of AI",
            ],
        },

    ],


    intermediate: [

        {
            id: "ds-intermediate-1",
            title: "Big Data, SQL & BI",
            content: [
                "Big Data concepts",
                "SQL for Data Science",
                "Business Intelligence fundamentals",
                "Working with large datasets",
            ],
        },

        {
            id: "ds-intermediate-2",
            title: "Advanced Analytics & Gen AI",
            content: [
                "Advanced analytics concepts",
                "Generative AI",
                "Practical analytics workflows",
                "AI-powered data applications",
            ],
        },

        {
            id: "ds-intermediate-3",
            title: "Capstone Preparation",
            content: [
                "Capstone project planning",
                "Problem identification",
                "Data preparation",
                "Project workflow",
                "Project presentation preparation",
            ],
        },

        {
            id: "ds-intermediate-4",
            title: "Feature Engineering & Unsupervised ML",
            content: [
                "Feature engineering",
                "Feature preparation",
                "Unsupervised Machine Learning",
                "Working with practical datasets",
            ],
        },

    ],


    advanced: [

        {
            id: "ds-advanced-1",
            title: "Advanced Statistics & Time Series",
            content: [
                "Advanced statistics",
                "Statistical analysis",
                "Time series concepts",
                "Time series analysis",
                "Practical forecasting concepts",
            ],
        },

        {
            id: "ds-advanced-2",
            title: "Data Pipelines & BI Storytelling",
            content: [
                "Data pipelines",
                "Data processing workflows",
                "Business Intelligence",
                "Data storytelling",
                "Presenting analytical insights",
            ],
        },

        {
            id: "ds-advanced-3",
            title: "Advanced Capstone Project & Presentation",
            content: [
                "Advanced Data Science project",
                "Project implementation",
                "Data analysis",
                "Model application",
                "Project documentation",
                "Final project presentation",
            ],
        },

    ],
};